import { LoggerInstance } from "@/domains/logging/types";
import { objectModule } from "@/modules/object";
import { noop } from "lodash-es";

export const initializeLoggerClient = async () => {
  type ConsoleLogFun = Console["error"] | Console["warn"] | Console["info"] | Console["debug"];

  const logMessage = async (
    message: string,
    info: Record<string, unknown>,
    person: unknown,
    consoleLogFun: ConsoleLogFun
  ) => {
    const consoleLogDetails = objectModule.compactNullOrUndefined({
      ...info,
      person,
    });

    consoleLogFun(message, consoleLogDetails);
  };

  const loggerClient: LoggerInstance = {
    trace: async ({ message, info = {}, person }) => {
      logMessage(message, info, person, console.trace);
    },
    debug: async ({ message, info = {}, person }) => {
      logMessage(message, info, person, console.debug);
    },
    info: async ({ message, info = {}, person }) => {
      logMessage(message, info, person, console.info);
    },
    warn: async ({ message, info = {}, person }) => {
      logMessage(message, info, person, console.warn);
    },
    error: async ({ message, info = {}, person }) => {
      logMessage(message, info, person, console.error);
    },
    flushLogs: async () => {
      return noop();
    },
  };

  return loggerClient;
};
